import React, { Component } from 'react';
import './JumpableZoomableDragable.css';
import TwoFingerTouch from '../ui_core/TwoFingerTouch';
import ZoomableDragable from './ZoomableDragable';
import IconButton from './IconButton';
import DynamicImage from '../images/DynamicImage';
import FitType from '../images/FitType';
import UrlHelper from '../core/UrlHelper';
import Urls from '../urls/Urls';
import ParameterErrors from '../errors/ParameterErrors';
const{throwNotProvided}=ParameterErrors;
export default class JumpableZoomableDragable extends Component {
	constructor(props){
		super(props);
		const {className, images, updateExternalZoomSource, zoomMax, zoomMin, rootUrl}=props;
		this._className=className;
		this._zoomMax = zoomMax;
		this._zoomMin = zoomMin;
		this._updateExternalZoomSource=updateExternalZoomSource?updateExternalZoomSource:null;
		this._loadImage= this._loadImage.bind(this);
		this._rootUrl = rootUrl?UrlHelper.makeSureSlashOnEnd(rootUrl):null;
		this._elementRef = React.createRef();
		this._zoomableDragableRef = React.createRef();
		this._getAspectRatio= this._getAspectRatio.bind(this);
		this._handleClickLeft= this._handleClickLeft.bind(this);
		this._handleClickRight= this._handleClickRight.bind(this);
		this.state={noMoreLeft:true, noMoreRight:true};
		this._index = 0;
	}
	_getAspectRatio(){
		const element = this._elementRef.current;
		if(element===null)return 1;
		return element.offsetWidth/element.offsetHeight;
	}
	componentDidUpdate(previousProps){
		const imagesChanged = previousProps.images!==this.props.images;
		const rootUrlChanged = previousProps.rootUrl!==this.props.rootUrl;
		if(imagesChanged){
			this._images = this.props.images;
			this.setState({noMoreLeft:true, noMoreRight:this._images.length<=1});
		}
		if(rootUrlChanged){
			const rootUrl = this.props.rootUrl;
			this._rootUrl = rootUrl?UrlHelper.makeSureSlashOnEnd(rootUrl):null;
		}
		if(imagesChanged||rootUrlChanged){
				this._index=0;
				this._loadImage();
		}
	}
	_loadImage(){
		const hasAtLeastOneImage = this._images&&(this._images.length>0);
		if(!hasAtLeastOneImage)return;
		const dynamicImageOrImagePathString = this._images[this._index];
		const isImagePathString = typeof(dynamicImageOrImagePathString)==='string';
		const relativeUrl = isImagePathString
			?dynamicImageOrImagePathString
			:dynamicImageOrImagePathString.getLargestEntry().relativePath;
		const url = (this._rootUrl===null?'':this._rootUrl)+UrlHelper.removeStartSlash(relativeUrl);
		const fitToHeight = false;
		this._zoomableDragableRef.current.load(url, fitToHeight);
	}
	_handleClickLeft(){
		this._index-=1;
		const noMoreLeft = this._index<=0;
		if(noMoreLeft){
			this._index=0;
		}
		this.setState({noMoreLeft:noMoreLeft, noMoreRight:false});
		this._loadImage();
	}
	_handleClickRight(){
		if(!this._images)return;
		this._index+=1;
		const noMoreRight = this._index>=this._images.length-1;
		if(noMoreRight){
			this._index=this._images.length-1;
		}
		this.setState({noMoreRight:noMoreRight, noMoreLeft:false});
		this._loadImage();
	}
	render() {
		let className = "jumpable-zoomable-dragable";
		if(this._className)
			className+=' '+this._className;
		if(this.state.noMoreLeft)
			className+=' no-more-left';
		if(this.state.noMoreRight)
			className+=' no-more-right';
		return (
			<div className={className} ref ={this._elementRef}>
				<ZoomableDragable
					getContainerAspectRatio={this._getAspectRatio}
					updateExternalZoomSource={this._updateExternalZoomSource} 
					zoomMax={this._zoomMax} zoomMin={this._zoomMin} 
					parentElementRef={this._elementRef}
					ref={this._zoomableDragableRef}>
				</ZoomableDragable>
				<IconButton imgUrl={Urls.assets+'icons/UI_Button_Open.png'}
				onClick={this._handleClickLeft} className="left-button"></IconButton>
				<IconButton imgUrl={Urls.assets+'icons/UI_Button_Close.png'}
				onClick={this._handleClickRight} className="right-button"></IconButton>
			</div>);
	}
}
